import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=a8a14260&scoped=true&"
import script from "./UpdateButton.vue?vue&type=script&lang=js&"
export * from "./UpdateButton.vue?vue&type=script&lang=js&"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=a8a14260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a14260",
  null
  
)

export default component.exports